import { wrapFontFamily } from 'common/components/entities/Text/utils'
import PropTypes from 'prop-types'
import PreviewBanner from 'publisher/components/core/PreviewBanner'
import { usePage } from 'publisher/store'
import pageSelectors from 'publisher/store/page/pageSelectors'
import React from 'react'
import Meta from '../components/core/Meta'
import PageUi from './ui/PageUi'

function CustomLoginPage({ children }) {
  const globalTextFontProperties = usePage(
    pageSelectors.getGlobalFontProperties,
  )
  return (
    <PageUi
      $textFontFamily={wrapFontFamily(globalTextFontProperties.fontFamily)}
      $textFontWeight={globalTextFontProperties.fontWeight}
      $textFontStyle={globalTextFontProperties.fontStyle}
    >
      <Meta />
      <PreviewBanner />
      {children}
    </PageUi>
  )
}

CustomLoginPage.propTypes = {
  children: PropTypes.node.isRequired,
}

export default CustomLoginPage
